import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';
import { getErrorJson } from '@mm/utils';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { unbusyAll } from '../actions/commonActions';

export default (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError) => {
    if (error instanceof Response) {
      const responseErrorBody = await getErrorJson(error);
      if (error.status === UNPROCESSABLE_ENTITY && responseErrorBody.errors) {
        dispatch(unbusyAll());
        return responseErrorBody.errors;
      }
    }
    return commonHandler(dispatch)(error);
  };
